export default "__VITE_ASSET__BPGciCkd__"